import React from 'react'
import styled from 'styled-components'

const CaseFooter = styled.div`
    margin-top: 8.75rem;
    display: grid;
    column-gap: 1rem;
    grid-template-columns: [spacer] 1fr [case-footer-1] 2fr [spacer] 1fr [case-footer-2] 3fr [spacer] 1fr [case-footer-3] 3fr [spacer] 1fr;
    .case-footer-1 {
        grid-area: case-footer-1;
    }
    .case-footer-2 {
        grid-area: case-footer-2;
    }
    .case-footer-3 {
        grid-area: case-footer-3;
    }

    h2.cs-year {
        margin-top: 3rem;
    }
    @media all and (max-width: 767px) {
        margin-top: 4.375rem;
        display: block;
        .case-footer-2, .case-footer-3 {
            margin-top: 3rem;
        }
    }
`

const CaseStudyFooter = ({
    year,
    brandName,
    touchpoints,
    partners
}) => {
    return (
        <div className="contain">
            <CaseFooter>
                <div className="case-footer-1">
                    <h2>Client</h2>
                    <p>{brandName}</p>
                    <h2 className="cs-year">Year</h2>
                    <p>{year}</p>
                </div>
                 <div className="case-footer-2">
                     {partners && <h2>Partners</h2>}
                     <div dangerouslySetInnerHTML={{__html: partners}} />   
                </div>
                 <div className="case-footer-3">
                    {touchpoints && <h2>Touchpoints</h2>}
                     <div dangerouslySetInnerHTML={{__html: touchpoints}} />   
                </div>

            </CaseFooter>
            
        </div>
    )
}

export default CaseStudyFooter
